module.exports = __webpack_public_path__ + "static/img/teaser_streckennetz.a39102b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teaser_streckennetz.jpg
// module id = wrLf
// module chunks = 1